import PDF from "../website-behaviors/PDF.js";

class CiteseerxPdf extends PDF {
	identifier() {
		return "CiteseerxPdf";
	}

	isPDFDownloadable() {
		return true;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "citeseerx.ist.psu.edu"
			&& location.pathname.match(/\/download/);
	}
}

export default CiteseerxPdf;
